var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlogBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 913,
    viewBox: "0 0 1920 913",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1920 913C1920 913 1920 190.512 1920 96.999C1873.26 87.743 1817.52 109.59 1768.95 100.45C1720.82 91.394 1678.56 49.725 1628.44 42.415C1579.8 35.32 1525 62.775 1474.67 57.405C1425.65 52.177 1379.58 13.91 1329.13 10.392C1279.84 6.954 1227.72 38.331 1177.22 36.596C1127.76 34.897 1078.47 0 1028 0C977.532 0 928.254 34.897 878.792 36.596C828.3 38.331 776.181 6.953 726.895 10.39C676.446 13.908 630.37 52.175 581.353 57.404C531.023 62.772 476.226 35.318 427.587 42.411C377.46 49.722 335.198 91.391 287.067 100.447C237.247 109.821 179.877 86.977 132.416 98.126C83.399 109.64 46.108 154.225 0 167.999C0 201.082 0 913 0 913H1920Z",
    fill: "#F9F6F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 913,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogBg);
export default __webpack_public_path__ + "static/media/blog-bg.18014bb4b1628475a357f9bbf57ec556.svg";
export { ForwardRef as ReactComponent };